<template>
	<div class="p-grid">
		<div class="p-col-12" v-if="proposal.assignedDate && proposal.assignedBeamTime">
			<div style="color: darkorange; font-size: 1.5em;">
				<span style="margin-right: 1em;">已分配机时：</span>
				<span style="margin-right: 1em;">{{showDateTime(proposal.assignedDate)}}</span>
				<span>{{proposal.assignedBeamTime}}小时</span>
			</div>
		</div>

		<div class="p-col-12 p-md-12 p-lg-8 p-xl-3 p-order-0 p-order-md-0 p-order-lg-0 p-order-xl-0">
			<div class="card p-fluid">
				<h4 style="color: RGB(22,105,196)">项目基本信息</h4>
				<div class="p-field">
					<label>实验名称</label>
					<div class="data-item">{{proposal.experimentName}}</div>
				</div>
				<div class="p-field">
					<label>申请类型</label>
					<div class="data-item">{{proposal.applicationType}}</div>
				</div>
				<div class="p-field">
					<label>项目来源和性质</label>
					<div class="data-item">{{proposal.projectProperty}}</div>
				</div>
				<div class="p-field">
					<label>预期开展实验的日期</label>
					<div class="data-item">{{showDateTime(proposal.expectedDate)}}</div>
				</div>

				<h4 style="color: RGB(22,105,196)">实验负责人信息</h4>
				<div class="p-field">
					<label>姓名</label>
					<div class="data-item">{{proposal.ownerName}}</div>
				</div>
				<div class="p-field">
					<label>单位</label>
					<div class="data-item">{{proposal.ownerOrganization}}</div>
				</div>
				<div class="p-field">
					<label>职称</label>
					<div class="data-item">{{proposal.ownerTitle}}</div>
				</div>
				<div class="p-field">
					<label>电话</label>
					<div class="data-item">{{proposal.ownerPhone}}</div>
				</div>
				<div class="p-field">
					<label>邮箱</label>
					<div class="data-item">{{proposal.ownerEmail}}</div>
				</div>
				<div class="p-field">
					<label>通讯地址</label>
					<div class="data-item">{{proposal.ownerAddress}}</div>
				</div>

				<h4 style="color: RGB(22,105,196)">实验参与人员</h4>
				<DataTable :value="proposal.participants" responsiveLayout="scroll">
					<Column field="name" header="姓名"></Column>
					<Column field="organization" header="单位"></Column>
					<Column field="phone" header="电话"></Column>
					<template #empty>
						No records found.
					</template>
				</DataTable>

				<h4 style="color: RGB(22,105,196)">样品及质子束流需求</h4>
				<div class="p-field">
					<label>样品类型及名称</label>
					<div class="data-item">{{proposal.sampleType}}</div>
				</div>
				<div class="p-field">
					<label>质子能量范围 (MeV)</label>
					<div class="data-item">{{proposal.protonEnergyRange}}</div>
				</div>
				<div class="p-field">
					<label>束流注量率 （p/cm2/s） 或辐照剂量 (Gy) 要求</label>
					<div class="data-item">{{proposal.protonBeamIntensity}}</div>
				</div>
				<div class="p-field">
					<label>质子束斑大小 (mm*mm)</label>
					<div class="data-item">{{proposal.protonBeamSpotSize}}</div>
				</div>
				<div class="p-field">
					<label>申请束流时间（h, 包含实验准备时间）</label>
					<div class="data-item">{{proposal.requestBeamTime}}</div>
				</div>
				<div class="p-field">
					<label>其他设备需求</label>
					<div class="data-item">{{proposal.otherDeviceRequirement}}</div>
				</div>

				<h4 style="color: RGB(22,105,196)">样品安全审查项目</h4>
				<div class="p-field">
					<label>样品形态</label>
					<div class="data-item">
						<span v-for="(item, index) in proposal.sampleState" :key="index" class="data-item" style="margin-right: 1em">{{item}}</span>
					</div>
					<div class="data-item">{{proposal.sampleStateDetail}}</div>

					<label>样品体积 (mm*mm*mm)</label>
					<div class="data-item">{{proposal.sampleVolume}}</div>

					<label>样品重量 (g)</label>
					<!-- <div class="data-item">
						<span v-for="(item, index) in proposal.sampleWeight" :key="index" class="data-item" style="margin-right: 1em">{{item}}</span>
					</div> -->
					<div class="data-item">{{proposal.sampleWeight}}</div>
					<div class="data-item">{{proposal.sampleWeightDetail}}</div>

					<label>安全性申报</label>
					<div class="data-item">
						<span v-for="(item, index) in proposal.sampleSecurityDeclaration" :key="index" class="data-item" style="margin-right: 1em">{{item}}</span>
					</div>
					<div class="data-item">{{proposal.sampleSecurityRadiationDetail}}</div>
					
					<label>样品环境特殊要求</label>
					<div class="data-item" style="white-space: pre;">{{proposal.sampleEnvironmentSpecialRequirement}}</div>
				</div>
			</div>
		</div>

		<div class="p-col-12 p-md-12 p-lg-8 p-xl-6 p-order-1 p-order-md-1 p-order-lg-2 p-order-xl-1">
			<div class="card p-fluid">
				<h4 style="color: RGB(22,105,196);">研究背景和意义</h4>
				<div class="p-field">
					<div class="data-item" style="min-height:18em">{{proposal.researchBackground}}</div>
				</div>

				<h4 style="color: RGB(22,105,196)">研究内容和预期成果</h4>
				<div class="p-field">
					<div class="data-item" style="min-height:18em">{{proposal.researchContent}}</div>
				</div>

				<h4 style="color: RGB(22,105,196)">其他实验条件及其他说明</h4>
				<div class="p-field">
					<div class="data-item" style="min-height:18em">{{proposal.otherComment}}</div>
				</div>

				<h4 style="color: RGB(22,105,196)">附件信息</h4>
				<div class="data-item">
					<div v-for="(item, index) in proposal.attachments" :key="index" style="font-size: 1em; margin-top: .2em;" class="p-field">
						<i style="margin-right: .5em" class="fa fa-file-o"></i>
						<span style="margin-right: 1em">{{ item.name }}</span>
						<span style="margin-right: 4em">{{ Math.round(item.size/1000) }}KB</span>
						<span style="margin-right: 1em; color: RGB(22,105,196); cursor: pointer;" @click="onDownloadClick(item.name, item.attachmentId)">下载</span>
					</div>
					<div v-if="!(proposal.attachments && proposal.attachments.length)">无</div>
				</div>
			</div>
		</div>

		<div class="p-col-12 p-md-12 p-lg-4 p-xl-3 p-order-2 p-order-md-2 p-order-lg-1 p-order-xl-2">
			<div class="card p-fluid">
				<div style="margin-left: -30%;">
					<ProposalStatus :timeline="timeline" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import fileDownload from 'js-file-download';
import ProposalService from '../service/ProposalService';
import ProposalStatus from './ProposalStatus';
const dateFormat = require('dateformat');

export default {
	data() {
		return {
			timeline: [],
		}
	},

	props: {
		proposal: Object
	},

	proposalService: null,

	created() {
		this.proposalService = new ProposalService();
	},

	mounted() {
		this.proposalService.buildProposalTimeline(this.proposal)
		.then(timeline => {
			this.timeline = timeline;
		}).catch(error => {
			if(error.response) {
				this.$toast.add({ severity: 'error', summary: '提案状态构建失败', detail: error.response.data.message });
			} else {
				this.$toast.add({ severity: 'error', summary: '提案状态构建失败', detail: error.message });
			}
		});
	},

	methods: {
		onDownloadClick(filename, id) {
			this.downloading = true;
			this.proposalService.getAttachment(id)
			.then((response) => {
				fileDownload(response.data, filename);
			}).catch(error => {
				this.$toast.add({ severity: 'error', summary: '操作失败', detail: error.message });
			}).finally(() => {
				this.downloading = false;
			});
		},
		showDate(value) {
            return dateFormat(value, "yyyy-mm-dd");
        },
        showTime(value) {
            return dateFormat(value, "HH:MM");
        },
        showDateTime(value) {
            return dateFormat(value, "yyyy-mm-dd HH:MM");
        },
	},

	components: {
        'ProposalStatus': ProposalStatus
	},

	computed: {
        
    },

	watch: {
		proposal(val) {
			this.proposalService.buildProposalTimeline(val).then(timeline => {
				this.timeline = timeline;
			});
		}
	}
}
</script>

<style scoped>
.data-item {
	background-color: rgba(33,150,243,0.2);
	min-height: 1.5em;
	margin-bottom: .8em;
}
</style>
